import { ReportTableColumn } from "../../models/reports.model";
import { TransactionsMenuEnum } from "./report-transactions.enum";
import { DataType } from "src/app/common/models/enums/common.enum";

export class TransactionsReportConstant {

    static transactionMenu = [
        {
            label: 'reports.overview',
            name: TransactionsMenuEnum.overview,
        },
        {
            label: 'reports.propertyTransactions',
            name: TransactionsMenuEnum.property_transaction,
        },
        {
            label: 'reports.unitTransactions',
            name: TransactionsMenuEnum.unit_transaction,
        }
    ]

    static propertyTransactionBHRColumns: ReportTableColumn[] = [
        {
          header: 'property_name',
          columnName: 'reports.PropertyName',
          field: 'property_name',
          isSortable: true,
          border: false,
          isContainsHTML: false,
          showOnMap: true,
          isAnchor: true
      },

      {
        header: 'transaction_date',
        columnName: 'reports.transactionDate',
        field: 'transaction_date',
        isSortable: true,
        border: false,
        isContainsHTML: false,
      },
      {
        header: 'transaction_type',
        columnName: 'reports.transactionType',
        field: 'transaction_type',
        border: false,
        isSortable: true,
        isContainsHTML: false,
      },
      {
        header: 'value',
        columnName: 'reports.value',
        field: 'value',
        border: true,
        isSortable: true,
        valSymbol: '',
        isContainsHTML: true,
        convertNumber: true,
        symbol: DataType.currencyCode,
        recordType: true
      },
      {
          header: 'land_area',
          columnName: 'reports.transaction_area',
          field: 'land_area',
          border: false,
          isSortable: true,
          symbol: DataType.squareMeter,
          isContainsHTML: false,
          convertNumber: true
      },
      {
        header: 'transaction_rate_sqm',
        columnName: 'reports.property_transaction_rate',
        field: 'transaction_rate_sqm',
        border: false,
        isSortable: true,
        isContainsHTML: false,
        convertNumber: true,
        symbol: DataType.currencyWithSquareMeter,
        },
      {
          header: 'transaction_rate',
          columnName: 'reports.property_transaction_rate',
          field: 'transaction_rate',
          border: false,
          isSortable: true,
          isContainsHTML: false,
          convertNumber: true,
          symbol: DataType.currencyWithSquareFeet,
      },
       {
          header: 'parcel_no',
          columnName: 'reports.parcelNumber',
          field: 'parcel_no',
          isSortable: true,
          border: false,
          isContainsHTML: false,
          showOnMap: false,
          isAnchor: false
      },
      {
          header: 'block',
          columnName: 'reports.block',
          field: 'block',
          border: false,
          isSortable: true,
          isContainsHTML: false
      },
      {
          header: 'neighborhood',
          columnName: 'reports.NEIGHBORHOODS',
          field: 'neighborhood',
          isSortable: true,
          border: false,
          isContainsHTML: false
      },
      {
          header: 'zone',
          columnName: 'reports.zone',
          field: 'zone',
          isSortable: true,
          border: false,
          isContainsHTML: false
      }
  ]

    static propertyTransactionDefaultColumns: ReportTableColumn[] = [
        {
          header: 'property_name',
          columnName: 'reports.PropertyName',
          field: 'property_name',
          isSortable: true,
          border: false,
          isContainsHTML: false,
          showOnMap: true,
          isAnchor: true
      },

      {
        header: 'transaction_date',
        columnName: 'reports.transactionDate',
        field: 'transaction_date',
        isSortable: true,
        border: false,
        isContainsHTML: false,
      },
      {
        header: 'transaction_type',
        columnName: 'reports.transactionType',
        field: 'transaction_type',
        border: false,
        isSortable: true,
        isContainsHTML: false,
      },
      {
        header: 'value',
        columnName: 'reports.value',
        field: 'value',
        border: true,
        isSortable: true,
        valSymbol: '',
        isContainsHTML: true,
        convertNumber: true,
        symbol: DataType.currencyCode,
        recordType: true
      },
      {
          header: 'land_area',
          columnName: 'reports.transaction_area',
          field: 'land_area',
          border: false,
          isSortable: true,
          symbol: DataType.squareMeter,
          isContainsHTML: false,
          convertNumber: true
      },
      {
          header: 'transaction_rate',
          columnName: 'reports.property_transaction_rate',
          field: 'transaction_rate',
          border: false,
          isSortable: true,
          isContainsHTML: false,
          convertNumber: true,
          symbol: DataType.currencyWithSquareMeter,
      },
       {
          header: 'parcel_no',
          columnName: 'reports.parcelNumber',
          field: 'parcel_no',
          isSortable: true,
          border: false,
          isContainsHTML: false,
          showOnMap: false,
          isAnchor: false
      },
      {
          header: 'block',
          columnName: 'reports.block',
          field: 'block',
          border: false,
          isSortable: true,
          isContainsHTML: false
      },
      {
          header: 'neighborhood',
          columnName: 'reports.NEIGHBORHOODS',
          field: 'neighborhood',
          isSortable: true,
          border: false,
          isContainsHTML: false
      },
      {
          header: 'zone',
          columnName: 'reports.zone',
          field: 'zone',
          isSortable: true,
          border: false,
          isContainsHTML: false
      }
  ]

    static propertyTransactionColumns: ReportTableColumn[] = [
      {
        header: 'property_name',
        columnName: 'reports.PropertyName',
        field: 'property_name',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: true,
        isAnchor: true
    },
    {
      header: 'transaction_date',
      columnName: 'reports.transactionDate',
      field: 'transaction_date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
    {
      header: 'transaction_type',
      columnName: 'reports.transactionType',
      field: 'transaction_type',
      border: false,
      isSortable: true,
      isContainsHTML: false,
    },
    {
      header: 'value',
      columnName: 'reports.value',
      field: 'value',
      border: true,
      isSortable: true,
      valSymbol: '',
      isContainsHTML: true,
      convertNumber: true,
      symbol: DataType.currencyCode,
      recordType: true
    },
    {
        header: 'land_area',
        columnName: 'reports.transaction_area',
        field: 'land_area',
        border: false,
        isSortable: true,
        symbol: DataType.squareMeter,
        isContainsHTML: false,
        convertNumber: true
    },
    {
        header: 'transaction_rate',
        columnName: 'reports.property_transaction_rate',
        field: 'transaction_rate',
        border: false,
        isSortable: true,
        isContainsHTML: false,
        convertNumber: true,
        symbol: DataType.currencyWithSquareMeter,
    },
     {
        header: 'parcel_no',
        columnName: 'reports.parcelNumber',
        field: 'parcel_no',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: false,
        isAnchor: false
    },
    {
        header: 'ref_no',
        columnName: 'reports.PACI_No',
        field: 'ref_no',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: false,
        isAnchor: false
    },
    {
        header: 'block',
        columnName: 'reports.block',
        field: 'block',
        border: false,
        isSortable: true,
        isContainsHTML: false
    },
    {
        header: 'neighborhood',
        columnName: 'reports.NEIGHBORHOODS',
        field: 'neighborhood',
        isSortable: true,
        border: false,
        isContainsHTML: false
    },
    {
        header: 'zone',
        columnName: 'reports.zone',
        field: 'zone',
        isSortable: true,
        border: false,
        isContainsHTML: false
    }
]
    static propertyTransactionSaudiColumns: ReportTableColumn[] = [
      {
        header: 'property_name',
        columnName: 'reports.PropertyName',
        field: 'property_name',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: true,
        isAnchor: true
    },

    {
      header: 'transaction_date',
      columnName: 'reports.transactionDate',
      field: 'transaction_date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
    {
      header: 'transaction_type',
      columnName: 'reports.transactionType',
      field: 'transaction_type',
      border: false,
      isSortable: true,
      isContainsHTML: false,
    },
    {
      header: 'value',
      columnName: 'reports.value',
      field: 'value',
      border: true,
      isSortable: true,
      valSymbol: '',
      isContainsHTML: true,
      convertNumber: true,
      symbol: DataType.currencyCode,
      recordType: true
    },
    {
        header: 'land_area',
        columnName: 'reports.transaction_area',
        field: 'land_area',
        border: false,
        isSortable: true,
        symbol: DataType.squareMeter,
        isContainsHTML: false,
        convertNumber: true
    },
    {
        header: 'transaction_rate',
        columnName: 'reports.property_transaction_rate',
        field: 'transaction_rate',
        border: false,
        isSortable: true,
        isContainsHTML: false,
        convertNumber: true,
        symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'parcel_no',
      columnName: 'reports.parcelNumber',
      field: 'parcel_no',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false
    },
    {
        header: 'plan_no',
        columnName: 'reports.plan_number',
        field: 'plan_no',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: false,
        isAnchor: false
    },
    {
        header: 'neighborhood',
        columnName: 'reports.NEIGHBORHOODS',
        field: 'neighborhood',
        isSortable: true,
        border: false,
        isContainsHTML: false
    },
    {
        header: 'zone',
        columnName: 'reports.zone',
        field: 'zone',
        isSortable: true,
        border: false,
        isContainsHTML: false
    }
]

  static propertyTransactionExpandColumns: any[] = [
    { field : 'property_name', convertNumber: false, blankColumn: true},
    { field : 'transaction_date', convertNumber: false },
    { field : 'transaction_type', convertNumber: false },
    { field : 'value', convertNumber: true, contentBg : true },
    { field : 'land_area', convertNumber: true },
    { field : 'transaction_rate', convertNumber: true },
    { field : 'block', convertNumber: false },
    { field : 'neighborhood', convertNumber: false },
    { field : 'zone', convertNumber: false }
  ]
    static housevillaProjectColumns: ReportTableColumn[] = [
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'type',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'block',
            columnName: 'reports.block',
            field: 'block',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'land_area',
            columnName: 'reports.land_area',
            field: 'land_area',
            isSortable: true,
            border: false,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'builtup_area',
            columnName: 'reports.builtup_area',
            field: 'builtup_area',
            border: false,
            isSortable: true,
            isContainsHTML: false,
            symbol: DataType.squareMeter,
            convertNumber: true
        },
        {
            header: 'floor_number',
            columnName: 'reports.no_of_floor',
            field: 'floor_number',
            border: false,
            isSortable: true,
            isContainsHTML: true
        },
        {
            header: 'no_of_bedroom',
            columnName: 'reports.no_of_bedroom',
            field: 'no_of_bedroom',
            border: false,
            isSortable: true,
            valSymbol: '',
            isContainsHTML: false,
        },
        {
            header: 'no_of_bathroom',
            columnName: 'reports.no_of_bathroom',
            field: 'no_of_bathroom',
            border: false,
            isSortable: true,
            valSymbol: '',
            isContainsHTML: false,
        }
    ]
  static unitTransactionColumns: ReportTableColumn[] = [
    {
      header: 'unit_uid',
      columnName: 'reports.unit_uid',
      field: 'unit_uid',
      isSortable: true,
      border: false,
      isContainsHTML: false,

    },
    {
      header: 'property_name',
      columnName: 'reports.PropertyName',
      field: 'property_name',
      border: false,
      isSortable: true,
      showOnMap: true,
      isAnchor: true
    },
    {
      header: 'date',
      columnName: 'reports.transactionDate',
      field: 'date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
    {
      header: 'transaction_type_m',
      columnName: 'reports.transactionType',
      field: 'transaction_type_m',
      border: false,
      isSortable: true,
      isContainsHTML: false,
    },
    {
      header: 'transaction_value',
      columnName: 'reports.value',
      field: 'transaction_value',
      border: true,
      isSortable: true,
      valSymbol: '',
      symbol: DataType.currencyCode,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'area',
      columnName: 'reports.unit_area',
      field: 'area',
      border: false,
      isSortable: true,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      border: false,
      isSortable: true,
      isContainsHTML: false,
      convertNumber: true,
      symbol: DataType.currencyWithSquareMeter,
    },
     {
      header: 'parcel_no',
      columnName: 'reports.parcelNumber',
      field: 'parcel_no',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false
    },
    {
      header: 'block_name',
      columnName: 'reports.block',
      field: 'block_name',
      border: false,
      isSortable: true,
      isContainsHTML: false
    },
    {
      header: 'neigh_name',
      columnName: 'reports.NEIGHBORHOODS',
      field: 'neigh_name',
      isSortable: true,
      border: false,
      isContainsHTML: false
    },
    {
      header: 'zoning',
      columnName: 'reports.zone',
      field: 'zoning',
      isSortable: true,
      border: false,
      isContainsHTML: false
    }
  ]

  static unitTransactionKWTColumns: ReportTableColumn[] = [
    {
      header: 'unit_uid',
      columnName: 'reports.unit_uid',
      field: 'unit_uid',
      isSortable: true,
      border: false,
      isContainsHTML: false,

    },
    {
      header: 'property_name',
      columnName: 'reports.PropertyName',
      field: 'property_name',
      border: false,
      isSortable: true,
      showOnMap: true,
      isAnchor: true
    },
    {
      header: 'date',
      columnName: 'reports.transactionDate',
      field: 'date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
    {
      header: 'transaction_type_m',
      columnName: 'reports.transactionType',
      field: 'transaction_type_m',
      border: false,
      isSortable: true,
      isContainsHTML: false,
    },
    {
      header: 'transaction_value',
      columnName: 'reports.value',
      field: 'transaction_value',
      border: true,
      isSortable: true,
      valSymbol: '',
      symbol: DataType.currencyCode,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'area',
      columnName: 'reports.unit_area',
      field: 'area',
      border: false,
      isSortable: true,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      border: false,
      isSortable: true,
      isContainsHTML: false,
      convertNumber: true,
      symbol: DataType.currencyWithSquareMeter,
    },
     {
      header: 'parcel_no',
      columnName: 'reports.parcelNumber',
      field: 'parcel_no',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false
    },
    {
        header: 'ref_no',
        columnName: 'reports.PACI_No',
        field: 'ref_no',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: false,
        isAnchor: false
    },
    {
      header: 'block_name',
      columnName: 'reports.block',
      field: 'block_name',
      border: false,
      isSortable: true,
      isContainsHTML: false
    },
    {
      header: 'neigh_name',
      columnName: 'reports.NEIGHBORHOODS',
      field: 'neigh_name',
      isSortable: true,
      border: false,
      isContainsHTML: false
    },
    {
      header: 'zoning',
      columnName: 'reports.zone',
      field: 'zoning',
      isSortable: true,
      border: false,
      isContainsHTML: false
    }
  ]

    static unitTransactionSAUColumns: ReportTableColumn[] = [
    {
      header: 'unit_uid',
      columnName: 'reports.unit_uid',
      field: 'unit_uid',
      isSortable: true,
      border: false,
      isContainsHTML: false,

    },
    {
      header: 'property_name',
      columnName: 'reports.PropertyName',
      field: 'property_name',
      border: false,
      isSortable: true,
      showOnMap: true,
      isAnchor: true
    },

    {
      header: 'date',
      columnName: 'reports.transactionDate',
      field: 'date',
      isSortable: true,
      border: false,
      isContainsHTML: false,
    },
    {
      header: 'transaction_type_m',
      columnName: 'reports.transactionType',
      field: 'transaction_type_m',
      border: false,
      isSortable: true,
      isContainsHTML: false,
    },
    {
      header: 'transaction_value',
      columnName: 'reports.value',
      field: 'transaction_value',
      border: true,
      isSortable: true,
      valSymbol: '',
      symbol: DataType.currencyCode,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'area',
      columnName: 'reports.unit_area',
      field: 'area',
      border: false,
      isSortable: true,
      symbol: DataType.squareMeter,
      isContainsHTML: false,
      convertNumber: true
    },
    {
      header: 'transaction_rate',
      columnName: 'reports.transaction_rate',
      field: 'transaction_rate',
      border: false,
      isSortable: true,
      isContainsHTML: false,
      convertNumber: true,
      symbol: DataType.currencyWithSquareMeter,
    },
    {
      header: 'parcel_no',
      columnName: 'reports.parcelNumber',
      field: 'parcel_no',
      isSortable: true,
      border: false,
      isContainsHTML: false,
      showOnMap: false,
      isAnchor: false
    },
     {
        header: 'plan_no',
        columnName: 'reports.plan_number',
        field: 'plan_no',
        isSortable: true,
        border: false,
        isContainsHTML: false,
        showOnMap: false,
        isAnchor: false
    },
    {
      header: 'neigh_name',
      columnName: 'reports.NEIGHBORHOODS',
      field: 'neigh_name',
      isSortable: true,
      border: false,
      isContainsHTML: false
    },
    {
      header: 'zoning',
      columnName: 'reports.zone',
      field: 'zoning',
      isSortable: true,
      border: false,
      isContainsHTML: false
    }
  ]

  static unitTransactionExpandColumns: any[] = [
    { field: 'unit_uid', convertNumber : false, blankColumn: true},
    {field: 'property_name',convertNumber : false, blankColumn: true},
    {field: 'transaction_date', convertNumber : false},
    {field: 'transaction_type',convertNumber : false},
    {field: 'value', convertNumber: true, contentBg : true},
    {field: 'unit_area', convertNumber: true},
    {field: 'transaction_rate', convertNumber: true},
    {field: 'block_name',convertNumber : false},
    {field: 'neigh_name', convertNumber : false},
    {field: 'zone', convertNumber: false}
  ]

    static propertyTransactionHistoryColumns: ReportTableColumn[] = [
        {
            header: 'date_of_transaction',
            columnName: 'reports.date_of_transaction',
            field: 'date_of_transaction',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'trans_type',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: true,
            valSymbol: '',
            isContainsHTML: false,
            convertNumber: true
        }
    ]

    static unitTransactionHistoryColumns: ReportTableColumn[] = [
        {
            header: 'date_of_transaction',
            columnName: 'reports.date_of_transaction',
            field: 'date_of_transaction',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'type',
            columnName: 'reports.type',
            field: 'type',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'unit_sub_type',
            columnName: 'reports.unit',
            field: 'unit_sub_type',
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'unit_area',
            columnName: 'reports.unit_area',
            field: 'unit_area',
            symbol: DataType.squareMeter,
            isSortable: true,
            border: false,
            isContainsHTML: false
        },
        {
            header: 'value',
            columnName: 'reports.value',
            field: 'value',
            border: true,
            isSortable: true,
            valSymbol: '',
            isContainsHTML: false,
            convertNumber: true
        }
    ]
}
